import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from "connected-react-router";

import App from './App';
import * as serviceWorker from './serviceWorker';

import { icons } from './assets/icons';

import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import { history, store } from './store';
import shinhanTheme from './theme';
React.icons = icons

ReactDOM.render(
  <Provider store={store}>
  <ConnectedRouter history={history}>
    <ThemeProvider theme={shinhanTheme}>
      <App />
    </ThemeProvider>
  </ConnectedRouter>
</Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
